import util from 'util'

/**
 * Formats an object for display using Node's util.inspect
 * @param {any} obj - The object to inspect
 * @param {boolean} [colors=true] - Whether to use colors in the output
 * @returns {string} A formatted string representation of the object
 * @description Provides a readable string representation of objects with full depth inspection
 */
export function inspect(obj: any, colors = true): string {
  return util.inspect(obj, false, null, colors)
}
